import React, { Component } from 'react';
import firebase from './../Firestore'
import { Link } from 'react-router-dom';

import CategoriaNombre from './CategoriaNombre'
import Precio from './Precio'
import Imagen from './Imagen'

import NavBar from './NavBar'

//import config from 'react-global-configuration';

class Show extends Component {

  constructor(props) {
    super(props);

    this.unsubscribe = null;

    this.state = {
      producto: {},
      key: ''
    };
  }

    async componentDidMount() {

    const ref = firebase.firestore().collection('producto').doc(this.props.match.params.id);
    this.unsubscribe = await ref.get().then((doc) => {
      if (doc.exists) {
        this.setState({
          producto: doc.data(),
          key: doc.id,
          isLoading: false
        });
      } else {
        console.log("No such document!");
      }
    });


  }

  delete(id){
    firebase.firestore().collection('producto').doc(id).delete().then(() => {
      console.log("Document successfully deleted!");
      this.props.history.push("/admin")
    }).catch((error) => {
      console.error("Error removing document: ", error);
    });
  }


  render() {
    console.log("render", this.state.producto.categoriaID)
    return (
      <div className="container">
        <NavBar history={this.props.history} />
        <div className="panel panel-default">
          <div className="panel-heading">
            <h3 className="panel-title">
              {this.state.producto.nombre}
            </h3>
          </div>
          <div className="panel-body">
            <dl>
              <dt>Categoria:</dt>
              <dd><CategoriaNombre categoriaID={this.state.producto.categoriaID} /></dd>
                {(this.state.producto.imagen) &&
                  <div>
                  <dt>Imagen:</dt>
                  <dd><Imagen imagen={this.state.producto.imagen} nombre={this.state.producto.nombre} /></dd>
                  </div>
                }

              <dt>Descripcion:</dt>
              <dd>{this.state.producto.descripcion}</dd>
              <dt>Orden listado en categoria:</dt>
              {(this.state.producto.orden > 0 && typeof(this.state.producto.orden) !== "undefined") ? (
                <dd><span className="mr-2 text-primary"><small>Orden aparicion: {this.state.producto.orden}</small></span></dd>
              ) : (
                <p>No se establecio</p>
              )}

              <dt>Se puede vender fraccionado (ej. pizza en mitades de dos sabores):</dt>
              <dd><span className="mr-2"><small>{this.state.producto.seFracciona ? "SI" : "NO"}</small></span></dd>

                <dt>Precio:</dt>
                <dd><span className="text-success h6 mr-2"><Precio precioAConvertir={this.state.producto.precio}/></span></dd>





            </dl>
            <Link to={`/admin/edit/${this.state.key}`} className="btn btn-success">Editar</Link>&nbsp;
            <button onClick={this.delete.bind(this, this.state.key)} className="btn btn-danger">Delete</button>
          </div>
        </div>
      </div>
    );
  }
}

export default Show;
